export enum ReservationType {
  PEOPLE = 'PEOPLE',
  TABLE = 'TABLE',
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/enums/reservation-type.enum.ts